import { render, staticRenderFns } from "./button-setting.vue?vue&type=template&id=dfd17134&scoped=true"
import script from "./button-setting.vue?vue&type=script&lang=js"
export * from "./button-setting.vue?vue&type=script&lang=js"
import style0 from "./button-setting.vue?vue&type=style&index=0&id=dfd17134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd17134",
  null
  
)

export default component.exports